var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.99811 8.67244L3.99835 8.67268L9.4994 13.9527C9.49942 13.9527 9.49944 13.9527 9.49946 13.9527C9.64402 14.0921 9.8326 14.15 10.0124 14.15C10.1998 14.15 10.3825 14.0755 10.5189 13.9586L10.519 13.9588L10.5254 13.9527L16.0019 8.67244C16.1994 8.48205 16.1994 8.18097 16.0019 7.99057C15.9126 7.90445 15.7887 7.85299 15.6624 7.85299C15.536 7.85299 15.4122 7.90445 15.3228 7.99057L10.0123 13.0991L4.68955 7.99057C4.68951 7.99053 4.68946 7.99049 4.68942 7.99044C4.49502 7.80314 4.19246 7.80319 3.99811 7.99057C3.80063 8.18097 3.80063 8.48205 3.99811 8.67244Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.3
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.8e327b7a.svg";
export { ForwardRef as ReactComponent };